<template>
  <div class="flex items-center">
    <div class="step p-[20] flex-center" :class="setClass">
      <div class="flex">
        <template v-for="(item, i) in stepList[typeKey]">
          <div class="flex items-center items-center" :class="{ 'is-active': activeNum == i + 1 }">
            <p class="step-index mr-[10]" :class="{ active: activeNum >= i + 1 }">
              <i v-if="activeNum > i + 1" class="el-icon-check"></i><span v-else>{{ i + 1 }}</span>
            </p>
            <p class="step-title leading-[20]" :class="{ active: activeNum >= i + 1 }">{{ item.name }}</p>
          </div>
          <div v-if="i + 1 < stepList[typeKey].length" class="pl-[8] pr-[8]"><i class="icon icon-left">&#xe646;</i>
          </div>
        </template>
      </div>
      <div class="flex justify-self-end h-[20] items-center" v-if="$route.query.tradeNo && showTradeNo">
        <div class="leading-[20] w-[50] tit mr-[8] t-[13] t-[#606266]">订单号</div>
        <div class="max-w-[300] leading-[20] t-[#606266] break-word cursor-pointer t-[13]" title="双击复制" @dblclick="copyItem($route.query.tradeNo)">{{ $route.query.tradeNo }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  name: "dg-step",
  mixins: [mixin],
  props: {
    setClass: {
      type: String,
      default: "w-[1024]",
    },
    active: {
      type: [String, Number],
      default: 1,
    },
    type: {
      type: [String, Number],
      default: 0,
    },
    showTradeNo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // activeNum: 1,
      // typeKey: "",
      stepList: {
        //工程投标保函
        GongcTenderbidInsure: [{ name: "选项目" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //政采投标保函
        PurchaseTenderbidInsure: [{ name: "选项目" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //政采合同履约
        PurchaseContractFulfillInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //工程合同履约
        GongcContractFulfillInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        // 建筑工程团意险
        GongcConstructionTeamInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //建筑工程一切险
        GongcConstructionAllRiskInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //农民工工资保函
        GongcPeasantInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //工程质量保函
        GongcQualityInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //法院诉讼
        CourtLowsuitInsure: [{ name: "填信息" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //法院诉讼
        CourtLowsuitModify: [{ name: "填信息" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        // 安责险
        GongcSafeLiabilityInsure: [{ name: "选项目" }, { name: "选机构" }, { name: "完善材料" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        // 安责险
        WinbidLoanApply: [{ name: "额度查询" }, { name: "签署合同" }, { name: "资信报告" }, { name: "正式授信" }, { name: "申请支用" }, { name: "等待放款" }],
        uuuuuuuu: [{ name: "额度查询" }, { name: "签署合同" }, { name: "资信报告" }, { name: "正式授信" }, { name: "申请支用" }, { name: "等待放款" }],
        // 海关
        CustomsInsure: [{ name: "海关信息" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //工程预付款
        GongcOwnerAdvancePaymentInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //业主支付
        OwnerEnsurePaymentInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //政采预付款
        PurchaseOwnerAdvancePaymentInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        //政采预付款
        AuctionInsure: [{ name: "选项目" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        // 纸质保函
        PaperInsure: [{ name: "选项目" }, { name: "上传纸质保函" }, { name: "完成提交" }],
        // PaperInsure: [{ name: "选项目" }, { name: "上传纸质保函" }, { name: "验真审核" }],
        TravelInsure: [{ name: "投保信息" }, { name: "完善材料" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }],
        CivilComplaintDocument: [{ name: "案由选择" }, {name: "案情描述"}, {name: "要素补充确认"}, {name: "文书生成"}, {name: "完成"}], // 民事起诉状文书生成
        PreservationDocument: [{ name: "保全类型选择" }, {name: "保全描述"}, {name: "要素补充确认"}, {name: "文书生成"}, {name: "完成"}], // 保全申请书文书生成
        CarRiskInsure: [{ name: "填信息" }, { name: "选机构" }, { name: "确认" }, { name: "签章" }, { name: "支付" }], // 汽车险
      },
      showRefine: {
        GongcTenderbidInsure: false, //工程投标保函
        GongcSafeLiabilityInsure: true, // 安责险
        PurchaseTenderbidInsure: false, //政采投标保函
        CourtLowsuitInsure: true, //法院诉讼
        PurchaseContractFulfillInsure: true, //政采合同履约
        GongcContractFulfillInsure: true, //工程合同履约
        GongcConstructionTeamInsure: true, //建筑工程团意险
        GongcConstructionAllRiskInsure: true, //建筑工程一切险
        GongcPeasantInsure: true, ///农民工工资保函
        CourtLowsuitModify: true, //法院诉讼
        PurchaseContractInsure: true, //政采合同履约
        PaperInsure: true, //纸质保函
        GongcQualityInsure: true, //工程质量保函
        WinbidLoanApply: true, //工程质量保函
        CustomsInsure: true, //工程质量保函
        AuctionInsure: true, //工程质量保函
        TravelInsure: true, //文旅保函
      },
    };
  },
  computed: {
    activeNum() {
      return Number(this.active)
    },
    typeKey() {
      if (this.$route.query && this.$route.query.taction) {
        return this.$route.query.taction;
      } else {
        return this.type;
      }
    }
  },
  methods: {},
  mounted() { },
  created() {
    // this.handleDoubleClick()
    // this.$nextTick(() => {
    //   if (this.$route.query && this.$route.query.taction) {
    //     this.typeKey = this.$route.query.taction;
    //   } else {
    //     this.typeKey = this.type;
    //   }
    // });
  },
};
</script>
<style scoped lang="less">
// @import '~@/assets/css/var.less';

.step {
  // flex-shrink: 0;
  // box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 8px 12px -4px rgba(0, 0, 0, 0.12), 0px 4px 4px -2px rgba(0, 0, 0, 0.05), inset 0px -2px 0px 0px rgba(0, 0, 0, 0.08);

  .tit {
    background: #fafafa;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #e4e7ed;
    text-align: center;
  }
}

.icon-left {
  color: #cfcdcd;
  zoom: 0.8;
}

.step-index {
  width: 20px;
  background-color: #f0f2f5;
  text-align: center;
  line-height: 20px;
  color: #909399;
  border-radius: 50%;
  font-size: 12px;

  &.active {
    background-color: @theme;
    color: #ffffff;
  }
}

.step-title {
  color: #909399;

  &.active {
    color: #303133;
  }
}

.is-active {
  position: relative;

  &::before {
    content: "";
    display: block;
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: @theme;
  }
}
</style>
